import React from 'react';

const TreeListEditPopup = ({ 
  newItem, 
  setNewItem, 
  savedQueries, 
  setLoader, 
  getData, 
  getThemeURL 
}) => {
  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#374151",
  };
  
  console.log("new item HO_LIST",newItem)

  const handleDataSourceChange = async (serviceName) => {
    setLoader(true);
    if (!serviceName) {
      setNewItem({
        ...newItem,
        dataSource: "bank_branch_details",
        data: [],
        cardStyles: {},
        fieldsConfig: [],
        value: "",
        valueKey: "",
        fieldConfigs: [],
        allAvailableFields: []
      });
      return;
    }

    const matchedQuery = savedQueries.find(q => q.serviceName === serviceName);
    if (!matchedQuery) {
      setLoader(false);
      return;
    }

    const queryObject = typeof matchedQuery.queryBuilder === "string"
      ? JSON.parse(matchedQuery.queryBuilder)
      : matchedQuery.queryBuilder;

    const filters = {};

    try {
      const userResponse = await getData(getThemeURL);
      if (userResponse && Array.isArray(userResponse) && userResponse.length > 0) {
        const user = userResponse[0];
        if (user.branch_id) filters.branch_id = user.branch_id;
        if (user.bank_id) filters.bank_id = user.bank_id;
      }
    } catch (error) {
      console.error("Error fetching user profile for filters:", error);
    }

    const enhancedQuery = {
      ...queryObject,
      filters: { ...queryObject.filters, ...filters },
    };

    try {
      const response = await fetch("/nifi/fetchQuery", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(enhancedQuery),
      });

      const result = await response.json();

      if (result.data && result.data.length > 0) {
        const availableFields = Object.keys(result.data[0] || {});
        const hiddenIdFields = ['bank_id', 'branchdetails_id', 'branch_id'];
        const configurableFields = availableFields.filter(field =>
          !hiddenIdFields.includes(field.toLowerCase())
        );

        // Categorize fields
        const categorizedFields = configurableFields.map((field) => {
          const category = field.toLowerCase().includes('bank') ? 'bank' : 'branch';
          return {
            fieldName: field,
            color: "#000000",
            fontSize: "small",
            fontSizeValue: 12,
            textAlignment: "left",
            enabled: true,
            category: category
          };
        });

        const fieldsConfig = configurableFields.map((field) => ({
          fieldName: field,
          enabled: true
        }));

        const cardStyles = {};
        categorizedFields.forEach(config => {
          if (config.enabled) {
            cardStyles[`${config.fieldName}_color`] = config.color;
            cardStyles[`${config.fieldName}_fontSize`] = config.fontSizeValue;
            cardStyles[`${config.fieldName}_textAlignment`] = config.textAlignment;
          }
        });

        const enabledConfigurableFields = fieldsConfig.filter(config => config.enabled).map(config => config.fieldName);
        const idFields = availableFields.filter(field => hiddenIdFields.includes(field.toLowerCase()));
        const allIncludedFields = [...enabledConfigurableFields, ...idFields];

        const filteredData = result.data.map(item => {
          const filteredItem = {};
          allIncludedFields.forEach(field => {
            if (item.hasOwnProperty(field)) {
              filteredItem[field] = item[field];
            }
          });
          return filteredItem;
        });

        const cardDataSourceConfig = {
          data: filteredData,
          columns: result.columns || availableFields,
          serviceName: serviceName,
          availableFields: availableFields,
          configurableFields: configurableFields,
          hiddenIdFields: idFields,
          originalData: result.data
        };

        setNewItem({
          ...newItem,
          dataSource: serviceName,
          data: filteredData,
          cardStyles: cardStyles,
          fieldsConfig: fieldsConfig,
          dataSourceConfig: cardDataSourceConfig,
          value: "",
          valueKey: "",
          fieldConfigs: categorizedFields,
          allAvailableFields: availableFields
        });
      }
    } catch (error) {
      console.error("Error fetching HO bank list data source:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleFieldConfigChange = (fieldName, updates) => {
    const fieldIndex = newItem.fieldConfigs.findIndex(c => c.fieldName === fieldName);
    if (fieldIndex === -1) return;

    const updatedFieldConfigs = newItem.fieldConfigs.map((config, i) =>
      i === fieldIndex ? { ...config, ...updates } : config
    );

    const updatedCardStyles = { ...newItem.cardStyles };

    if (updates.enabled !== undefined) {
      const updatedFieldsConfig = newItem.fieldsConfig.map((config) =>
        config.fieldName === fieldName ? { ...config, enabled: updates.enabled } : config
      );

      if (updates.enabled) {
        updatedCardStyles[`${fieldName}_color`] = updatedFieldConfigs[fieldIndex].color;
        updatedCardStyles[`${fieldName}_fontSize`] = updatedFieldConfigs[fieldIndex].fontSizeValue;
        updatedCardStyles[`${fieldName}_textAlignment`] = updatedFieldConfigs[fieldIndex].textAlignment;
      } else {
        delete updatedCardStyles[`${fieldName}_color`];
        delete updatedCardStyles[`${fieldName}_fontSize`];
        delete updatedCardStyles[`${fieldName}_textAlignment`];
      }

      // Rebuild data array
      const originalData = newItem.dataSourceConfig?.originalData || [];
      const allAvailableFields = newItem.allAvailableFields || [];
      const enabledConfigurableFields = updatedFieldsConfig.filter(config => config.enabled).map(config => config.fieldName);
      
      const fieldsToIncludeInData = [...enabledConfigurableFields];
      if (allAvailableFields.includes('bank_id')) fieldsToIncludeInData.push('bank_id');
      if (allAvailableFields.includes('branch_id')) fieldsToIncludeInData.push('branch_id');
      if (allAvailableFields.includes('branchdetails_id')) fieldsToIncludeInData.push('branchdetails_id');

      const filteredData = originalData.map(item => {
        const filteredItem = {};
        fieldsToIncludeInData.forEach(field => {
          if (item.hasOwnProperty(field)) {
            filteredItem[field] = item[field];
          }
        });
        return filteredItem;
      });

      setNewItem({
        ...newItem,
        fieldConfigs: updatedFieldConfigs,
        fieldsConfig: updatedFieldsConfig,
        data: filteredData,
        cardStyles: updatedCardStyles
      });
    } else {
      // Handle style updates
      if (updatedFieldConfigs[fieldIndex].enabled) {
        if (updates.color) updatedCardStyles[`${fieldName}_color`] = updates.color;
        if (updates.fontSizeValue) updatedCardStyles[`${fieldName}_fontSize`] = updates.fontSizeValue;
        if (updates.textAlignment) updatedCardStyles[`${fieldName}_textAlignment`] = updates.textAlignment;
      }

      setNewItem({
        ...newItem,
        fieldConfigs: updatedFieldConfigs,
        cardStyles: updatedCardStyles
      });
    }
  };

  const renderFieldConfig = (fieldConfig, category) => {
    return (
      <div
        key={fieldConfig.fieldName}
        style={{
          marginBottom: "16px",
          padding: "12px",
          backgroundColor: "white",
          borderRadius: "6px",
          border: "1px solid #e5e7eb"
        }}
      >
        {/* Field Enable/Disable Toggle */}
        <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
          <input
            type="checkbox"
            checked={fieldConfig.enabled}
            onChange={(e) => handleFieldConfigChange(fieldConfig.fieldName, { enabled: e.target.checked })}
            style={{
              width: "16px",
              height: "16px",
              marginRight: "8px",
              accentColor: "#1a7a73",
              cursor: "pointer",
            }}
          />
          <label style={{
            fontSize: "14px",
            fontWeight: "600",
            color: fieldConfig.enabled ? "#374151" : "#9ca3af",
            cursor: "pointer"
          }}>
            {fieldConfig.fieldName}
          </label>
        </div>

        {/* Field Configuration Options */}
        {fieldConfig.enabled && (
          <div style={{ display: "flex", gap: "12px", alignItems: "flex-start", flexWrap: "wrap" }}>
            {/* Color Selection */}
            <div style={{ flex: "1 1 150px", minWidth: "120px" }}>
              <label style={{
                display: "block",
                marginBottom: "6px",
                fontSize: "12px",
                fontWeight: "500",
                color: "#6b7280"
              }}>
                Text Color
              </label>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <input
                  type="color"
                  value={fieldConfig.color}
                  onChange={(e) => handleFieldConfigChange(fieldConfig.fieldName, { color: e.target.value })}
                  style={{
                    width: "25px",
                    height: "25px",
                    border: "1px solid #d1d5db",
                    borderRadius: "4px",
                    cursor: "pointer",
                    backgroundColor: "transparent",
                  }}
                />
                <input
                  type="text"
                  value={fieldConfig.color}
                  onChange={(e) => handleFieldConfigChange(fieldConfig.fieldName, { color: e.target.value })}
                  style={{
                    flex: 1,
                    padding: "4px 6px",
                    borderRadius: "4px",
                    border: "1px solid #d1d5db",
                    fontSize: "11px",
                    outline: "none",
                  }}
                />
              </div>
            </div>

            {/* Font Size Selection */}
            <div style={{ flex: "1 1 150px", minWidth: "120px" }}>
              <label style={{
                display: "block",
                marginBottom: "6px",
                fontSize: "12px",
                fontWeight: "500",
                color: "#6b7280"
              }}>
                Font Size
              </label>
              <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                <select
                  value={fieldConfig.fontSize}
                  onChange={(e) => {
                    const fontSizeOption = e.target.value;
                    let fontSizeValue;
                    
                    switch (fontSizeOption) {
                      case "small": fontSizeValue = 12; break;
                      case "medium": fontSizeValue = 16; break;
                      case "large": fontSizeValue = 20; break;
                      case "extra-large": fontSizeValue = 24; break;
                      case "custom": fontSizeValue = fieldConfig.fontSizeValue || 12; break;
                      default: fontSizeValue = 12;
                    }

                    handleFieldConfigChange(fieldConfig.fieldName, {
                      fontSize: fontSizeOption,
                      fontSizeValue
                    });
                  }}
                  style={{
                    width: "90px",
                    padding: "4px 6px",
                    borderRadius: "4px",
                    border: "1px solid #d1d5db",
                    fontSize: "11px",
                    outline: "none",
                  }}
                >
                  <option value="small">Small</option>
                  <option value="medium">Medium</option>
                  <option value="large">Large</option>
                  <option value="extra-large">X-Large</option>
                  <option value="custom">Custom</option>
                </select>

                {fieldConfig.fontSize === "custom" && (
                  <input
                    type="number"
                    value={fieldConfig.fontSizeValue || 12}
                    onChange={(e) => handleFieldConfigChange(fieldConfig.fieldName, {
                      fontSizeValue: parseInt(e.target.value) || 12
                    })}
                    placeholder="px"
                    min="8"
                    max="72"
                    style={{
                      width: "50px",
                      padding: "4px 6px",
                      borderRadius: "4px",
                      border: "1px solid #d1d5db",
                      fontSize: "11px",
                      outline: "none",
                    }}
                  />
                )}
              </div>
            </div>

            {/* Text Alignment Selection */}
            <div style={{ flex: "1 1 150px", minWidth: "120px" }}>
              <label style={{
                display: "block",
                marginBottom: "6px",
                fontSize: "12px",
                fontWeight: "500",
                color: "#6b7280"
              }}>
                Text Alignment
              </label>
              <div style={{
                display: "flex",
                gap: "4px",
                border: "1px solid #d1d5db",
                borderRadius: "4px",
                padding: "2px",
                backgroundColor: "white"
              }}>
                {[
                  { value: "left", label: "L" },
                  { value: "center", label: "C" },
                  { value: "right", label: "R" },
                ].map((alignment) => (
                  <button
                    key={alignment.value}
                    type="button"
                    onClick={() => handleFieldConfigChange(fieldConfig.fieldName, { textAlignment: alignment.value })}
                    style={{
                      flex: 1,
                      padding: "4px 2px",
                      borderRadius: "2px",
                      border: "none",
                      backgroundColor: fieldConfig.textAlignment === alignment.value
                        ? "#1a7a73" : "transparent",
                      color: fieldConfig.textAlignment === alignment.value
                        ? "white" : "#6b7280",
                      cursor: "pointer",
                      fontSize: "10px",
                      fontWeight: "500",
                      transition: "all 0.2s",
                    }}
                    onMouseOver={(e) => {
                      if (fieldConfig.textAlignment !== alignment.value) {
                        e.currentTarget.style.backgroundColor = "#f3f4f6";
                      }
                    }}
                    onMouseOut={(e) => {
                      if (fieldConfig.textAlignment !== alignment.value) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    {alignment.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {/* Data Source Selection */}
      <div style={{ marginBottom: "16px" }}>
        <label style={labelStyle}>Data Source</label>
        <select
          value={newItem.dataSource || ""}
          disabled={true}
          onChange={(e) => handleDataSourceChange(e.target.value)}
          style={{
            width: "100%",
            padding: "12px 16px",
            borderRadius: "8px",
            border: "1px solid #d1d5db",
            fontSize: "14px",
            backgroundColor: "#f9fafb",
            color: "#6b7280",
            cursor: "not-allowed",
          }}
        >
          <option value="">Select data source</option>
          {savedQueries.map((query) => (
            <option key={query.id} value={query.serviceName}>
              {query.serviceName}
            </option>
          ))}
        </select>
      </div>

      {/* Field Configuration Section */}
      {newItem.fieldConfigs && newItem.fieldConfigs.length > 0 && (
        <div style={{ marginBottom: "16px" }}>
          <label style={{
            display: "block",
            marginBottom: "12px",
            fontSize: "14px",
            fontWeight: "bold",
            color: "#374151",
          }}>
            Configure Bank & Branch Fields
          </label>
          <div style={{
            maxHeight: "300px",
            overflowY: "auto",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "12px",
            backgroundColor: "#f9fafb"
          }}>
            {/* Bank Fields Section */}
            <div style={{ marginBottom: "20px" }}>
              <h4 style={{ 
                margin: "0 0 12px 0", 
                fontSize: "13px", 
                fontWeight: "600", 
                color: "#374151",
                padding: "8px 12px",
                backgroundColor: "#e0f2fe",
                borderRadius: "4px",
                border: "1px solid #0891b2"
              }}>
                Bank Fields
              </h4>
              {newItem.fieldConfigs
                .filter(config => config.category === "bank")
                .map((fieldConfig) => renderFieldConfig(fieldConfig, "bank"))}
            </div>

            {/* Branch Fields Section */}
            <div>
              <h4 style={{ 
                margin: "0 0 12px 0", 
                fontSize: "13px", 
                fontWeight: "600", 
                color: "#374151",
                padding: "8px 12px",
                backgroundColor: "#fef3c7",
                borderRadius: "4px",
                border: "1px solid #f59e0b"
              }}>
                Branch Fields
              </h4>
              {newItem.fieldConfigs
                .filter(config => config.category === "branch")
                .map((fieldConfig) => renderFieldConfig(fieldConfig, "branch"))}
            </div>
          </div>
        </div>
      )}

      {/* Bank Card Color */}
      <div style={{ marginBottom: "16px" }}>
        <label style={{
          display: "block",
          marginBottom: "8px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#374151",
        }}>
          Bank Card Color
        </label>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}>
          <input
            type="color"
            value={newItem.bankCardColor || "#ffffff"}
            onChange={(e) => {
              const color = e.target.value;
              const updatedCardStyles = { ...newItem.cardStyles };
              updatedCardStyles.bank_card_color = color;
              
              setNewItem({
                ...newItem,
                bankCardColor: color,
                cardStyles: updatedCardStyles
              });
            }}
            style={{
              width: "50px",
              height: "40px",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
              cursor: "pointer",
              backgroundColor: "transparent",
            }}
          />
          <input
            type="text"
            value={newItem.bankCardColor || "#ffffff"}
            onChange={(e) => {
              const color = e.target.value;
              const updatedCardStyles = { ...newItem.cardStyles };
              updatedCardStyles.bank_card_color = color;
              
              setNewItem({
                ...newItem,
                bankCardColor: color,
                cardStyles: updatedCardStyles
              });
            }}
            placeholder="#ffffff"
            style={{
              flex: 1,
              padding: "10px 12px",
              borderRadius: "8px",
              border: "1px solid #d1d5db",
              backgroundColor: "white",
              fontSize: "14px",
              color: "#374151",
              outline: "none",
              transition: "border-color 0.2s",
            }}
            onFocus={(e) => (e.target.style.borderColor = "#1a7a73")}
            onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
          />
        </div>
      </div>

      {/* Branch Card Color */}
      <div style={{ marginBottom: "16px" }}>
        <label style={{
          display: "block",
          marginBottom: "8px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#374151",
        }}>
          Branch Card Color
        </label>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}>
          <input
            type="color"
            value={newItem.branchCardColor || "#ffffff"}
            onChange={(e) => {
              const color = e.target.value;
              const updatedCardStyles = { ...newItem.cardStyles };
              updatedCardStyles.branch_card_color = color;
              
              setNewItem({
                ...newItem,
                branchCardColor: color,
                cardStyles: updatedCardStyles
              });
            }}
            style={{
              width: "50px",
              height: "40px",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
              cursor: "pointer",
              backgroundColor: "transparent",
            }}
          />
          <input
            type="text"
            value={newItem.branchCardColor || "#ffffff"}
            onChange={(e) => {
              const color = e.target.value;
              const updatedCardStyles = { ...newItem.cardStyles };
              updatedCardStyles.branch_card_color = color;
              
              setNewItem({
                ...newItem,
                branchCardColor: color,
                cardStyles: updatedCardStyles
              });
            }}
            placeholder="#ffffff"
            style={{
              flex: 1,
              padding: "10px 12px",
              borderRadius: "8px",
              border: "1px solid #d1d5db",
              backgroundColor: "white",
              fontSize: "14px",
              color: "#374151",
              outline: "none",
              transition: "border-color 0.2s",
            }}
            onFocus={(e) => (e.target.style.borderColor = "#1a7a73")}
            onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
          />
        </div>
      </div>

      {/* Expand Icon Color */}
      <div style={{ marginBottom: "16px" }}>
        <label style={{
          display: "block",
          marginBottom: "8px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#374151",
        }}>
          Expand Icon Color
        </label>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}>
          <input
            type="color"
            value={newItem.expand_color || "#000000"}
            onChange={(e) => {
              const color = e.target.value;
              const updatedCardStyles = { ...newItem.cardStyles };
              updatedCardStyles.expand_color = color;
              
              setNewItem({
                ...newItem,
                expand_color: color,
                cardStyles: updatedCardStyles
              });
            }}
            style={{
              width: "50px",
              height: "40px",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
              cursor: "pointer",
              backgroundColor: "transparent",
            }}
          />
          <input
            type="text"
            value={newItem.expand_color || "#000000"}
            onChange={(e) => {
              const color = e.target.value;
              const updatedCardStyles = { ...newItem.cardStyles };
              updatedCardStyles.expand_color = color;
              
              setNewItem({
                ...newItem,
                expand_color: color,
                cardStyles: updatedCardStyles
              });
            }}
            placeholder="#000000"
            style={{
              flex: 1,
              padding: "10px 12px",
              borderRadius: "8px",
              border: "1px solid #d1d5db",
              backgroundColor: "white",
              fontSize: "14px",
              color: "#374151",
              outline: "none",
              transition: "border-color 0.2s",
            }}
            onFocus={(e) => (e.target.style.borderColor = "#1a7a73")}
            onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
          />
        </div>
      </div>
    </>
  );
};

export default TreeListEditPopup;
